import React, { CSSProperties } from "react";
import { useTranslation } from "react-i18next";
import { isDeviceVesta, VelavuDevice } from "velavu-js-api";
import {
	DynamicSignalLabel,
	mapStrengthSNR,
} from "../../elements/dynamic-signal";
import VelavuExpandMenu from "../../elements/velavu-expand-menu";
import VelavuSimpleTable from "../../elements/velavu-simple-table";
import { formatDateTime, mapLocationType } from "../../helper/language-helper";

export default function TabTagLocation(props: {
	style?: CSSProperties;
	className?: string;
	tag: VelavuDevice;
}) {
	const { t } = useTranslation();

	if (!props.tag.location) return null;

	return (
		<VelavuExpandMenu
			style={props.style}
			className={props.className}
			label={t("asset_detail.tag.location_section")}
		>
			<VelavuSimpleTable>
				<tbody>
					{props.tag.location !== undefined && (
						<tr>
							<td>{t("asset_detail.tag.location_type")}</td>
							<td>
								{mapLocationType(
									props.tag.location.location_type,
									t,
								)}
							</td>
						</tr>
					)}

					{isDeviceVesta(props.tag) &&
						props.tag.state?.gnss?.snr !== undefined && (
							<tr>
								<td>{t("asset_detail.tag.gps_signal")}</td>
								<td>
									<DynamicSignalLabel
										strength={mapStrengthSNR(
											props.tag.state.gnss.snr,
										)}
									/>
								</td>
							</tr>
						)}
					{isDeviceVesta(props.tag) &&
						props.tag.state?.gnss?.sats_in_view !== undefined && (
							<tr>
								<td>{t("asset_detail.tag.satellites")}</td>
								<td>{props.tag.state.gnss.sats_in_view}</td>
							</tr>
						)}
					{props.tag.location !== undefined && (
						<>
							<tr>
								<td>
									{t("asset_detail.tag.last_coordinates")}
								</td>
								<td>
									{props.tag.location.coordinates.join(
										", ",
									) ?? t("location_type.unknown")}
								</td>
							</tr>
							<tr>
								<td>{t("asset_detail.tag.last_updated")}</td>
								<td>
									{formatDateTime(
										props.tag.location.timestamp,
									)}
								</td>
							</tr>
							{props.tag.location.accuracy !== undefined && (
								<tr>
									<td>{t("asset_detail.tag.accuracy")}</td>
									<td>{`${props.tag.location.accuracy}m`}</td>
								</tr>
							)}
						</>
					)}
				</tbody>
			</VelavuSimpleTable>
		</VelavuExpandMenu>
	);
}
